module.exports = __webpack_public_path__ + "static/media/cockroach(24).d3a9dc0b.PNG";